import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import VueApexCharts from "vue3-apexcharts";
import Echo from 'laravel-echo'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Set up axios defaults
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

// Add axios interceptor for debugging
axios.interceptors.request.use(config => {
    console.log('Axios request:', config.method.toUpperCase(), config.url);
    return config;
}, error => {
    console.error('Axios request error:', error);
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    console.log('Axios response:', response.status, response.config.url);
    return response;
}, error => {
    console.error('Axios response error:', error.response?.status, error.response?.data);
    return Promise.reject(error);
});

import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import CanvasJSChart from '@canvasjs/vue-charts';
import CKEditor from '@ckeditor/ckeditor5-vue';

window.Pusher = require('pusher-js');

// Enable Pusher logging for debugging
if (process.env.NODE_ENV !== 'production') {
    window.Pusher.logToConsole = true;
}

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
})


InertiaProgress.init()

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title}`:``,
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .mixin({ methods: { route : route } })
            .mixin(require('./base'))
            .use(plugin)
            .use(VueAxios, axios)
            .use(Donut)
            .use(VueApexCharts)
            .use(CKEditor)
            .use(CanvasJSChart)
            .mount(el)
    },
})
